import { useCallback, useEffect, useRef } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useDirectSpeech } from '../../DirectSpeech/DirectSpeechProvider';
import { MenuPopover } from './MenuPopover';
import bundle from '../NovaComponents-Menu-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);

/**
 * @internal
 */
export const isCustomSection = section => {
  return 'render' in section;
};
/**
 * @internal
 */
export const MenuDesign = props => {
  const referenceElementRef = useRef(null);
  const popoverPositionRef = useRef();
  const {
    showFocus,
    focusLocation,
    onItemSelected
  } = props;
  const {
    x,
    y,
    dockingElement,
    verticalAlign = 'end',
    horizontalAlign = 'start'
  } = props.position;
  referenceElementRef.current = dockingElement ?? null;
  let placement = props.placement ?? 'bottom-start';
  if (dockingElement) {
    const verticalValue = verticalAlign === 'start' ? 'top' : 'bottom';
    const horizontalValue = horizontalAlign ?? 'start';
    placement = `${verticalValue}-${horizontalValue}`;
  } else {
    // This is an alternative scenario for new DOMRect(), since the constructor way causes some UTs to fail.
    if (popoverPositionRef.current?.x !== x || popoverPositionRef.current?.y !== y) popoverPositionRef.current = {
      bottom: y,
      height: 0,
      left: x,
      right: x,
      top: y,
      width: 0,
      x,
      y
    };
  }
  const narrator = useDirectSpeech();
  const localize = useTextLocalizer();
  const selectedIndicesRef = useRef();
  const isOpenRef = useRef(props.isOpen);
  isOpenRef.current = props.isOpen;
  const onSelected = useCallback((indices, key) => {
    if (!isOpenRef.current || selectedIndicesRef.current) return;
    selectedIndicesRef.current = [...indices];
    onItemSelected(indices, key);
  }, [onItemSelected]);
  useEffect(() => {
    if (!selectedIndicesRef.current) return;
    const indices = selectedIndicesRef.current;
    let section = props.sections[indices[0][0]];
    if (section && !isCustomSection(section)) {
      let item = section.items[indices[0][1]];
      for (let i = 1; i < indices.length; i++) {
        if (item?.subSections) {
          const [sectionIndex, itemIndex] = indices[i];
          section = item.subSections[sectionIndex];
          if (section && !isCustomSection(section)) {
            item = section.items[itemIndex];
          }
        }
      }
      if (section && item) {
        /*
         * For single-selectable menuitem, its checked value is not updated this time,
         * because of the value is caculated in MenuListDesign.
         */
        if (section.selectedKey !== undefined) item.checked = section.selectedKey === item.key;else if (section.selectedIndex !== undefined) item.checked = section.selectedIndex === indices[indices.length - 1][1];
        if (item.checked !== undefined) narrator?.notify(localize(item.checked ? 'item.checked.msg' : 'item.notChecked.msg', {
          item: item.text
        }));
      }
    }
    selectedIndicesRef.current = undefined;
  });
  return /*#__PURE__*/_jsx(MenuPopover, {
    ...props,
    isOpen: props.isOpen,
    referenceElementRef: referenceElementRef,
    placement: placement,
    position: popoverPositionRef.current,
    maxHeight: props.maxHeight,
    testId: props.testId,
    sections: props.sections,
    focusLocation: focusLocation,
    disabled: props.disabled,
    onKeyDown: props.onKeyDown,
    onItemSelected: onSelected,
    onItemClosed: props.onItemClosed,
    onItemHovered: props.onItemHovered,
    onItemLeaved: props.onItemLeaved,
    onSubmenuClosed: props.onSubmenuClosed,
    showFocus: showFocus,
    tokens: props.tokens,
    menuLevel: 0
  });
};
//# sourceMappingURL=MenuDesign.js.map